import CreateTagForm from './CreateTagForm';

export default CreateTagForm;
